import $ from 'jquery';

$(document).on('turbolinks:load', function () {
  const syncPairs = [
    ["business_name", "card_name"],
    ["business_name_of_firm", "card_name_of_firm"],
    ["business_ntn_no", "card_ntn_no"],
    ["business_gst_no", "card_gst_no"],
    ["business_cell_no", "card_cell_no"],
    ["business_phone_no", "card_phone_no"],
    ["business_address", "card_address"],
    ["membership_associations_categoryID", "associations_categoryID"],
    ["membership_designation","card_designation"],
    ["membership_status", "card_status"]
  ];

  syncPairs.forEach(([idA, idB]) => {
    const $elemA = $(`#${idA}`);
    const $elemB = $(`#${idB}`);

    if ($elemA.length === 0 || $elemB.length === 0) return;

    if ($elemA.is("select") && $elemB.is("select")) {
      $elemA.on("change", () => $elemB.val($elemA.val()).trigger('change'));
      $elemB.on("change", () => $elemA.val($elemB.val()).trigger('change'));
    } else {
      let isSyncing = false;

      $elemA.on("input", () => {
        if (!isSyncing) {
          isSyncing = true;
          $elemB.val($elemA.val());
          isSyncing = false;
        }
      });

      $elemB.on("input", () => {
        if (!isSyncing) {
          isSyncing = true;
          $elemA.val($elemB.val());
          isSyncing = false;
        }
      });
    }
  });
});
